// extracted by mini-css-extract-plugin
export default {"widget":"Widget_widget__F7ZZJ","widget_stretch":"Widget_widget_stretch__w5Qpw","content":"Widget_content__-givi"};